import {
  LOADING_COLORFAVORITES,
  LOADED_COLORFAVORITES,
  LOAD_COLORFAVORITES_FAILED,
  SET_COLORFAVORITES,
  ColorFavoritesAction,
  SET_SELECTED_COLORFAVORITE
} from './Actions';

import { ColorFavorite } from 'Types/ColorFavorites';

export interface ColorFavoritesState {
  items: ColorFavorite[];
  selectedItemName: string;
  loading: boolean;
  loaded: boolean;
  failed: boolean;
}

const initialState: ColorFavoritesState = {
  items: [],
  selectedItemName: '',
  loading: false,
  loaded: false,
  failed: false
};

export function colorFavoritesReducer(state = initialState, action: ColorFavoritesAction): ColorFavoritesState {
  switch (action.type) {
    case LOADED_COLORFAVORITES:
      return {
        items: action.items,
        selectedItemName: action.selectedItemName,
        loaded: true,
        loading: false,
        failed: false
      };
    case LOADING_COLORFAVORITES:
      return {
        items: [],
        selectedItemName: '',
        loading: true,
        loaded: false,
        failed: false
      };
    case LOAD_COLORFAVORITES_FAILED:
      return {
        items: [],
        selectedItemName: '',
        loading: false,
        loaded: false,
        failed: true
      };
    case SET_COLORFAVORITES:
      return {
        items: action.items,
        selectedItemName: action.selectedItemName,
        loading: false,
        loaded: true,
        failed: false
      };
    case SET_SELECTED_COLORFAVORITE:
      return {
        ...state,
        selectedItemName: action.selectedItemName
      };
    default:
      return state;
  }
}

